import axios from "axios";
import { PollCancelQuoteRequest, PollCancelQuoteResponse } from "redmond";
import { config } from "../../config";
import { getActivitiesCancelQuotePollPath } from "../paths";

export const getActivitiesCancelQuotePoll = async (
  req: PollCancelQuoteRequest
): Promise<PollCancelQuoteResponse> => {
  const res = await axios.put(getActivitiesCancelQuotePollPath, req, {
    baseURL: config.baseURL,
  });

  return res.data;
};
